import axiosInstance from "./AxiosInstance";

const CategoryService = {
  getCategories: async (page, limit, search, archived = false, isActive = null) => {
    try {
      let params = {};
      if (page && limit) {
        params = {
          ...params,
          page,
          limit,
        };
      }
      if (search) {
        params = {
          ...params,
          search,
        };
      }
      if (archived) {
        params.archived = true;
      }
      if (isActive !== null) {
        params.isActive = isActive;
      }
      
      const response = await axiosInstance.get("/v1/categories", {
        params,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getAllCategories: async (archived = false) => {
    try {
      const params = {
        page: 1,
        limit: 1000, // Very large limit to get all categories
        search: "",
      };
      
      if (archived) {
        params.archived = true;
      }
      
      const response = await axiosInstance.get("/v1/categories", {
        params,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getCategoryById(id) {
    return axiosInstance.get(`/v1/categories/${id}`);
  },

  createCategory: async (categoryData) => {
    try {
      const response = await axiosInstance.post("/v1/categories", categoryData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  updateCategory(id, categoryData) {
    return axiosInstance.put(`/v1/categories/${id}`, categoryData);
  },

  deleteCategory: async (categoryId) => {
    try {
      const response = await axiosInstance.delete(
        `/v1/categories/${categoryId}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  archiveCategory: async (categoryId, isArchived = true) => {
    try {
      const response = await axiosInstance.patch(`/v1/categories/${categoryId}/archive`, {
        isArchived
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default CategoryService;
